import { render, staticRenderFns } from "./UnansweredIcon.vue?vue&type=template&id=2862c395&"
import script from "./UnansweredIcon.vue?vue&type=script&lang=js&"
export * from "./UnansweredIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports